module.exports = __webpack_public_path__ + "static/integracao-receitas-bg-1e1d244de7b6a612acd7a0459c6a6186.jpg";